import "../styles/Hero.css";

const Hero = ({ onViewProjects, onViewLego, onViewCertifications }) => {
  const year = new Date().getFullYear();

  return (
    <section className="hero">
      <div className="hero-grid" />
      <div className="hero-glow" />

      <div className="hero-content">
        <div className="hero-badge">
          <span className="badge-dot" />
          Open to opportunities
        </div>

        <h1 className="hero-h1">
          Hi, I'm<br />
          <span className="hero-name">Marcus Uy</span>
        </h1>

        <p className="hero-subtitle">Software Engineer Graduate</p>

        <p className="hero-p">
          I build scalable, user-focused applications with strong foundations
          in software engineering principles.
        </p>

        {/* Primary CTAs */}
        <div className="hero-ctas">
          <button className="btn-primary" onClick={onViewProjects}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <path d="M9 18l6-6-6-6" />
            </svg>
            View Projects
          </button>

          <a
            href="/assets/MarcusUy_Resume_2026.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-resume"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
            </svg>
            View Resume
          </a>
        </div>

        {/* Social links */}
        <div className="hero-socials">
          <a
            href="https://github.com/marcus-justice31"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
            aria-label="GitHub"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.02 10.02 0 0 0 22 12.017C22 6.484 17.522 2 12 2z" />
            </svg>
            GitHub
          </a>

          <a
            href="https://linkedin.com/in/marcus-uy"
            target="_blank"
            rel="noopener noreferrer"
            className="social-link"
            aria-label="LinkedIn"
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
            LinkedIn
          </a>
        </div>

        {/* Secondary, lower-key links to bonus sections */}
        {(onViewLego || onViewCertifications) && (
          <div className="hero-secondary-links">
            {onViewCertifications && (
              <button className="hero-secondary-link" onClick={onViewCertifications}>
                🎓 View Certifications
              </button>
            )}
            {onViewLego && (
              <button className="hero-secondary-link" onClick={onViewLego}>
                🧱 Check out my LEGO City
              </button>
            )}
          </div>
        )}
      </div>

      <div className="hero-divider" />
      <span className="hero-corner-label">Marcus Uy · {year}</span>
    </section>
  );
};

export default Hero;